module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/default-banner-base-9c250edb6bef3a58029e42260f011369.png";